export default __webpack_public_path__ + "static/gmail-a2f2146f929409405da07c73ea1c8632.png";